import { Icon } from '@iconify/react';
import { useCanEdit } from './EditorOnly';
import { ApiTokensCard } from './ApiTokensCard';
import { Alert, Button, Card, CardContent, TextField } from '@mui/material';
import { FormEvent, useState } from 'react';
import { ApiError } from '../api/client';
import { useWorkspace } from '../workspace-context';
import { Box, Stack, Typography } from './mui-system';

export function WorkspaceOnboarding() {
  const editable = useCanEdit('settings.create');
  const { createWorkspace } = useWorkspace();
  const [name, setName] = useState('');
  const [siteUrl, setSiteUrl] = useState('https://');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSaving(true);
    setError('');
    try {
      await createWorkspace({ name, siteUrl });
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'Не удалось создать проект');
    } finally {
      setSaving(false);
    }
  }

  if (!editable)
    return (
      <Stack gap={2}>
        <Alert severity="info">
          Доступных проектов пока нет. Попросите супер-администратора открыть вам доступ к общему
          проекту.
        </Alert>
        <ApiTokensCard />
      </Stack>
    );

  return (
    <Box maxWidth={720} mx="auto" py={{ xs: 2, md: 5 }}>
      <Card sx={{ overflow: 'hidden' }}>
        <Box sx={{ height: 5, bgcolor: '#ff3366' }} />
        <CardContent sx={{ p: { xs: 2.5, md: 4 } }}>
          <Box
            sx={{
              width: 58,
              height: 58,
              display: 'grid',
              placeItems: 'center',
              bgcolor: '#ff3366',
              color: '#ffffff',
              borderRadius: 2,
              mb: 2,
            }}
          >
            <Icon icon="solar:radar-2-bold-duotone" width={30} />
          </Box>
          <Typography variant="h2" mb={1}>
            Создайте первый SEO-проект
          </Typography>
          <Typography color="text.secondary" mb={3}>
            Первый воркспейс станет общим для всех пользователей с доступом к дашборду. Укажите сайт
            для начала работы.
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}
          <Stack component="form" onSubmit={submit} gap={1.5}>
            <TextField
              label="Название проекта"
              value={name}
              onChange={(event) => setName(event.target.value)}
              required
              autoFocus
            />
            <TextField
              label="URL сайта"
              value={siteUrl}
              onChange={(event) => setSiteUrl(event.target.value)}
              required
              type="url"
            />
            <Button
              type="submit"
              variant="contained"
              size="large"
              disabled={saving}
              endIcon={<Icon icon="solar:arrow-right-linear" />}
              sx={{ alignSelf: 'flex-start', mt: 1 }}
            >
              {saving ? 'Создаём…' : 'Создать проект'}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
